import React, { ReactElement } from "react";
import { Text, Stack, Icon } from "sprint-common-web";

import { BuzzVersionReferenceResponse } from "../../../common/api/catalogue-api/buzz/BuzzReferenceResponse";

const getIconByMode = (mode: boolean): JSX.Element => {
    const iconName = mode ? "Accept" : "Cancel";
    return <Icon iconName={iconName} display="some" alignItems="center" />;
};
export const renderBuzzVersionItem = (props: BuzzVersionReferenceResponse | undefined): ReactElement | null => {
    if (!props) {
        return null;
    }
    const { id, isArchived, notes, name } = props;

    return (
        <Stack>
            <Stack verticalAlign="center">
                <Text value={`Id: ${id}`} styles={{ root: { fontSize: 12 } }}></Text>
            </Stack>
            <Stack verticalAlign="center">
                <Text value={`Name: ${name}`} styles={{ root: { fontSize: 12 } }}></Text>
            </Stack>
            {notes && (
                <Stack verticalAlign="center">
                    <Text value={`notes: ${notes}`} styles={{ root: { fontSize: 12 } }}></Text>
                </Stack>
            )}
            <Stack horizontal={true} verticalAlign="center">
                <Text value="Archived:" styles={{ root: { paddingRight: 10, fontSize: 12 } }}></Text>
                {getIconByMode(isArchived)}
            </Stack>
        </Stack>
    );
};
